import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import className from 'classnames';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { Warning as WarningIcon } from 'common/components/svgs';
import { inventoryType as InventoryType } from '~constants/listing-management';

const useStyle = makeStyles(
  theme => ({
    listingNoAvailableBox: {
      padding: '24px',
      background: theme.colors.gray1,
      position: 'absolute',
      zIndex: 5,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
    flexBox: {
      ...theme.flex.row,
    },
    commonFontStye: {
      ...theme.typography.body2,
      fontWeight: 400,
      color: theme.colors.titleColor,
    },
    waringContent: {
      width: '314px',
      marginBottom: '24px',
    },
    warningSvg: {
      width: '22px',
      fill: '#F5222D',
      marginRight: '16px',
    },
    footerBox: {
      ...theme.flex.mainEnd,
    },
    confirmbtn: {
      marginRight: '8px',
      color: theme.colors.bodyColor,
    },
    cancelbtn: {
      ...theme.typography.body2,
      fontWeight: 600,
    },
  }),
  { name: 'ListingNoAvailable' },
);
const ListingNoAvailable = props => {
  const { confirmHandle, isShow, NewClass, onCancel } = props;
  const classes = useStyle();
  const { t } = useTranslation();

  return (
    <>
      <If condition={isShow}>
        <div className={className([classes.listingNoAvailableBox], [NewClass])}>
          <div className={classes.flexBox}>
            <div>
              <WarningIcon className={classes.warningSvg} />
            </div>

            <div className={className(classes.waringContent, classes.commonFontStye)}>
              {t('cms:listing_no_inventory_warning')}
            </div>
          </div>
          <div className={classes.footerBox}>
            <Button
              className={className(classes.confirmbtn, classes.commonFontStye)}
              onClick={confirmHandle}
            >
              {t('cms:listing_no_inventory_confirm_btn')}
            </Button>
            <Button className={classes.cancelbtn} type="primary" onClick={onCancel}>
              {t('cms:listing_no_inventory_cancel_btn')}
            </Button>
          </div>
        </div>
      </If>
    </>
  );
};

ListingNoAvailable.prototype = {
  confirmHandle: PropTypes.func.isRequired,
  isShow: PropTypes.bool.isRequired,
  NewClass: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
};

export const isInVentoryCountsEmpty = unitTypes => {
  let isListingEmpty = false;
  unitTypes?.forEach(unitType => {
    const isRoomCountType = unitType?.node?.inventoryType === InventoryType.ROOM_COUNT;
    if (isListingEmpty && isRoomCountType) {
      return false;
    } else {
      isListingEmpty =
        isRoomCountType && unitType?.node?.listings?.some(listing => listing.inventoryCount === 0);
    }
  });

  return isListingEmpty;
};

export const InVentoryCountsZeroNum = unitTypes => {
  let number = 0;
  unitTypes?.forEach(unitType => {
    unitType?.node?.listings?.forEach(listing => {
      if (listing.inventoryCount === 0) {
        number++;
      }
    });
  });
  return number;
};

export default ListingNoAvailable;
